import { connect } from "react-redux";
import React, { Component, Fragment } from "react";

import { optionSelectHandler } from "@/features/assessments/Assessment";

import Button from "../UI/Button";
import {
  getNextQuestion,
  getPreviousQuestion,
  setSelectedOptions,
} from "../../redux/actions/a5Screening";
import ProgressBar from "../UI/ProgressBar";
import { Question } from "../Patient/Assessment";

import { COMPLETED_STEP, START_STEP } from "./A5Screening";

class A5InProgress extends Component {
  handleNextQuestion = () => {
    let requestBody = {
      id: this.props.a5Details.id,
      options: this.props.currentQuestion.options.filter((el) => {
        return this.props.selectedOptions.find((index) => index === el.index) !== undefined;
      }),
      question_id: this.props.currentQuestion.question_id,
    };

    this.props.getNextQuestion(requestBody, { dob: this.props.a5Details.dob });
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isLastQuestion && !this.props.currentQuestion) {
      this.props.nextStepHandler(COMPLETED_STEP);
    }
  }

  handlePrevQuestion = () => {
    if (this.props.completionPercentage === 0) {
      this.props.prevStepHandler(START_STEP);
    } else {
      this.props.getPreviousQuestion(
        { id: this.props.a5Details.id },
        { dob: this.props.a5Details.dob },
      );
    }
  };

  render() {
    return (
      <div>
        {this.props.currentQuestion && (
          <Fragment>
            <div className="container">
              <div className="my-4">
                <span>A5 Screening</span>
              </div>
              <ProgressBar height="12px" now={this.props.completionPercentage} />
              <Question
                classes="col-12 col-lg-6 px-2 px-lg-2 col-lg-4 d-flex py-2 tw:justify-center"
                currentQuestion={this.props.currentQuestion}
                excludeOuterClass={true}
                selectedOptions={this.props.selectedOptions}
                selectOption={(option) => optionSelectHandler(option, this)}
              />
              <div className="A5ButtonGroup d-flex h-100 align-items-center justify-content-between">
                <Button
                  className="Btn Btn--otl-pri mt-4"
                  onClick={this.handlePrevQuestion}
                  type="button"
                >
                  Previous
                </Button>
                <Button
                  className="Btn Btn--pri mt-4"
                  disabled={this.props.selectedOptions.length === 0 ? "disabled" : null}
                  onClick={this.handleNextQuestion}
                  type="button"
                >
                  {!this.props.isLastQuestion && "Next"}
                  {this.props.isLastQuestion && "Finish"}
                </Button>
              </div>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    a5Details: state.a5Screening.a5Details,
    completionPercentage: state.a5Screening.completionPercentage,
    currentQuestion: state.a5Screening.currentQuestion,
    isLastQuestion: state.a5Screening.isLastQuestion,
    lastSelectedOption: state.a5Screening.lastSelectedOption,
    selectedOptions: state.a5Screening.selectedOptions,
  };
};

export default connect(mapStateToProps, {
  getNextQuestion,
  getPreviousQuestion,
  setSelectedOptions,
})(A5InProgress);
